import React, { useState } from 'react';
import classnames from 'classnames';
import LocalizedMessage from 'react-l10n';
import AccountCreditCardForm from './AccountCreditCardForm';
import AccountCreditCardList from './AccountCreditCardList';
import { StripeProvider, Elements } from 'react-stripe-elements';

function AccountCreditCard(props) {
    const {
        isLoadingList,
        list,
        handleFormSubmission,
        currentBillingAddress,
        handleDelete,
        handleMakeDefault,
    } = props;
    const [showForm, setShowForm] = useState(false);

    return (
        <React.Fragment>
            <div className='card__header'>
                <span className='card__header-wrapper'>
                    <span className='card__header-icon'>
                        <span className='icon icon-freight-options' />
                    </span>
                </span>
                <h3 className='heading heading--lv4'>
                    <LocalizedMessage id={'ACCOUNT_CREDIT_CARD.HEADING'} />
                </h3>
            </div>
            <div className='vspace vspace--small'>
                <div className='text-box'>
                    <p>
                        <LocalizedMessage id={'ACCOUNT_CREDIT_CARD.CONTENT'} />
                    </p>
                </div>
            </div>
            <div className='row'>
                <div className='col-xs-12 col-md-7'>
                    <div className='vspace vspace--small'>
                        <AccountCreditCardList
                            isLoading={isLoadingList}
                            list={list}
                            onRemoveClick={handleDelete}
                            onMakeDefaultClick={handleMakeDefault}
                        />
                    </div>

                    <div className='tab-content'>
                        <div
                            id='default-card-form'
                            className={classnames(
                                'tab-pane',
                                showForm === false && 'active'
                            )}
                        >
                            <button
                                type='button'
                                className='button button-filter button--grey-border'
                                onClick={() => setShowForm(true)}
                            >
                                <span className='icon icon-plus-thick' />
                                <span>
                                    <LocalizedMessage
                                        id={'ACCOUNT_CREDIT_CARD.ADD_NEW'}
                                    />
                                </span>
                            </button>
                        </div>
                        <div
                            id='add-new-card-form'
                            className={classnames(
                                'tab-pane',
                                showForm === true && 'active'
                            )}
                        >
                            <StripeProvider apiKey={window.stripePublicKey}>
                                <Elements>
                                    <AccountCreditCardForm
                                        handleFormSubmission={
                                            handleFormSubmission
                                        }
                                        closeForm={() => {
                                            console.log(
                                                'Inside closeForm() before runnning setShowFrom(false)'
                                            );
                                            setShowForm(false);
                                        }}
                                        currentBillingAddress={
                                            currentBillingAddress
                                        }
                                    />
                                </Elements>
                            </StripeProvider>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default AccountCreditCard;
